import styled from "styled-components";
import { BbotAlert } from "top-component-library";

export const LegacyLinkAlert = styled(BbotAlert)`
  margin-bottom: 16px;
`;
